import React, {
  Component
} from 'react';
import {Redirect, withRouter} from 'react-router-dom'
import {withCookies} from "react-cookie";
import LoginForm from "../components/LoginForm";
import {ROUTES, STUDIO_SESSION_COOKIE_DEV, STUDIO_SESSION_COOKIE_PROD} from "../utils/constants";

class Login extends Component {
  render() {
    if (this.props.cookies.get(STUDIO_SESSION_COOKIE_DEV) || this.props.cookies.get(STUDIO_SESSION_COOKIE_PROD)) {
      return <Redirect to={ROUTES.PROJECTS}/>;
    }

    return (
      <LoginForm />
    );
  }
};

export default withRouter(withCookies(Login));
